module.exports = __webpack_public_path__ + "img/shibly.f973aaed.svg";